import React from "react";
import { motion } from "framer-motion";
import { MoireMark } from "@/components/MoireLogo";

const STAGES = [
  "Looking at the piece…",
  "Reading the colour…",
  "Finding its strongest matches…",
  "Styling the look…",
];

export default function AnalyzingSequence({ label = "MOIRÉ is styling", stages = STAGES, done = false }) {
  const [i, setI] = React.useState(0);
  React.useEffect(() => {
    if (done) return;
    const t = setInterval(() => setI((p) => Math.min(p + 1, stages.length - 1)), 1400);
    return () => clearInterval(t);
  }, [done, stages.length]);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6"
      data-testid="analyzing-sequence">
      <motion.div
        animate={done ? { scale: [1, 1.08, 1] } : { opacity: [0.6, 1, 0.6] }}
        transition={done ? { duration: 0.6 } : { duration: 2, repeat: Infinity }}
      >
        <MoireMark size={72} strokeWidth={2} />
      </motion.div>

      <div className="h-8 mt-10 overflow-hidden">
        {done ? (
          <motion.p
            key="verdict-flourish"
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
            className="font-serif italic text-3xl text-[#C8A97E]"
            data-testid="analyze-flourish">
            Clocked.
          </motion.p>
        ) : (
          <motion.p
            key={i}
            initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0 }}
            className="font-sans text-sm tracking-wider text-[#8A8170] uppercase">
            {stages[i]}
          </motion.p>
        )}
      </div>
    </div>
  );
}
